import { Helmet } from 'react-helmet-async'

export function StructuredData() {
  const webApplicationSchema = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "SAT Score Calculator",
    "applicationCategory": "EducationalApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Free Digital SAT score calculator to convert raw scores to scaled scores, calculate superscores, and convert ACT to SAT scores.",
    "url": "https://www.satscorescalculator.com",
    "browserRequirements": "Requires JavaScript. Modern web browser.",
    "featureList": [
      "Digital SAT Score Calculator",
      "SAT Superscore Calculator",
      "SAT Math Score Calculator",
      "SAT Reading Score Calculator",
      "ACT to SAT Conversion",
      "Practice Test Score Calculator"
    ]
  }

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is a raw score vs. scaled score?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A raw score is simply the number of questions you answered correctly. A scaled score (200-800 per section) is the standardized score that accounts for slight variations in test difficulty across different test dates."
        }
      },
      {
        "@type": "Question",
        "name": "How do I calculate my SAT score manually?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To calculate your SAT score manually, count correct answers for each section, use the official College Board conversion table to find scaled scores, then add them together. Our score calculator SAT tool does this automatically."
        }
      },
      {
        "@type": "Question",
        "name": "What is a superscore?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A superscore combines your best section scores from multiple test dates. Many colleges accept superscores, which can significantly improve your chances."
        }
      },
      {
        "@type": "Question",
        "name": "Is this calculator accurate?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Our SAT test score calculator uses official College Board conversion tables to provide accurate score estimates. However, actual test scores may vary slightly based on the specific test form and equating process."
        }
      }
    ]
  }

  const howToSchema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "How to Calculate Your SAT Score from a Raw Score",
    "description": "Step-by-step guide to converting your raw SAT scores to scaled scores and calculating your total SAT composite score.",
    "step": [
      {
        "@type": "HowToStep",
        "name": "Count Correct Answers",
        "text": "Count how many questions you answered correctly in each section. There is no penalty for wrong answers on the Digital SAT."
      },
      {
        "@type": "HowToStep",
        "name": "Use Conversion Table",
        "text": "Your raw score is converted to a scaled score (200-800) for each section using the official College Board conversion table."
      },
      {
        "@type": "HowToStep",
        "name": "Add Section Scores",
        "text": "Add your Math and Reading & Writing scaled scores together to get your total SAT composite score (400-1600)."
      },
      {
        "@type": "HowToStep",
        "name": "Track Progress",
        "text": "Use the calculator regularly to monitor improvement and estimate your SAT score over time."
      }
    ]
  }

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "SAT Scores Calculator",
    "url": "https://www.satscorescalculator.com",
    "logo": "https://lumi.new/lumi.ing/logo.png",
    "description": "Free SAT score calculator tools for high school students preparing for college admissions."
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(webApplicationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(howToSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  )
}
